/** Props para MUI Chip do nome da impressora conforme a marca. */
export function getPrinterBrandBadgeProps(brand) {
    const key = String(brand || '').trim().toLowerCase();

    if (key.includes('creality')) {
        return { color: 'success' };
    }

    if (key.includes('bambu')) {
        return {
            sx: {
                bgcolor: '#9e9e9e',
                color: '#fff',
                fontWeight: 600,
            },
        };
    }

    if (key.includes('flashforge') || key.includes('flash forge')) {
        return { color: 'info' };
    }

    return null;
}
